import { render } from "./HeaderSaruman.vue?vue&type=template&id=404bb3fe&scoped=true"
import script from "./HeaderSaruman.vue?vue&type=script&lang=js"
export * from "./HeaderSaruman.vue?vue&type=script&lang=js"

import "./HeaderSaruman.vue?vue&type=style&index=0&id=404bb3fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404bb3fe"]])

export default __exports__